import React, { Component } from 'react';
import Footer from '../components/Footer';
import Mainmenu from '../components/Mainmenu';
import Navbar from '../components/Navbar';
import CourseDocumentsSelectorContent from './CourseDocumentsSelectorContent';

export default class CourseDocumentsSelector extends Component {
    render() {
        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <CourseDocumentsSelectorContent />
                <Footer />
            </div>
        );
    }
}
